<div
        id="catalog-type-container"
        style="min-height: 100vh; position: relative"
>
  <navaar-header
          [title]="title"
          [color]="'#000000'"
  ></navaar-header>
  <section
    #containerHref
    class="wrapper-desc"
    [class.hidden]="!description"
    [innerHtml]="description | safeHtml"
  ></section>
  <div class="scrollbar container-scroll-div"
       [style.margin-top.px]="getDescriptionHeight()">
    <div class="wrapper-scroll-bar">
      <navaar-list-items
              class="catalog-list"
              *ngIf="books.length > 0"
              (go-to)="goToPage($event)"
              [disable-when-fetch-data]="isLoading"
              [isEnd]="isEnd"
              [items]="books"
              [type]="'none'"
              [more-icon]="false"
              [event-tracker-name]="'x_catalog_list_items'"
      ></navaar-list-items>
    </div>
  </div>
</div>


